import type { TypographyProps } from "@mui/material";
import { Typography, styled } from "@mui/material";

import { row } from "@citrine/atoms/layout";

export const InputArea = styled("div")(({ theme }) => ({
  ...row,
  background: theme.palette.grey[50],
  borderTop: `1px solid ${theme.palette.divider}`,
  gap: theme.spacing(1),
  padding: theme.spacing(1.5, 2),
}));

export const ContextIndicator = styled("div")(({ theme }) => ({
  backgroundColor: theme.palette.grey[50],
  borderBottom: `1px solid ${theme.palette.divider}`,
  padding: theme.spacing(0.75, 2),
}));

export const ContextIndicatorText = styled(Typography)<TypographyProps>(
  ({ theme }) => ({
    color: theme.palette.text.secondary,
  }),
);
